import { Component, Prop, State, h } from '@stencil/core';

import { onQuestionAnswered, onStateFieldAnswered } from '../../../actions/actions.answers';

@Component({
  tag: 'question-toggleselect',
  styleUrl: 'question-toggleselect.css',
})
export class QuestionToggleselect {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() isDirty: boolean = false;
  @Prop() answer: { value: string | boolean; comment?: string } | string | boolean = { value: undefined };
  @Prop() hasComment: boolean = false;
  @Prop() heading: string = '';
  @Prop() questionId: string = '';
  @Prop() canonicalName: string = '';
  @Prop() fieldName: string = '';
  @Prop() subHeading: string = '';
  @Prop() whenChanged: (value: boolean) => void = () => {};
  @Prop() inputStyle: 'toggleselect' | 'checkbox' = 'toggleselect';
  @Prop() dataTestId: string = '';

  @State() comment: string = '';
  @State() showComment: boolean = false;
  @State() value: boolean = false;

  get answerValue() {
    if (typeof this.answer === 'object') {
      return this.answer?.value;
    }
    return this.answer;
  }

  get answerComment() {
    if (typeof this.answer === 'object') {
      return this.answer?.comment;
    }
  }

  toggleComments = () => {
    this.showComment = !this.showComment;
  };

  componentWillLoad() {
    this.showComment = this.answerValue === 'true' || this.answerValue === true;
  }

  componentWillRender() {
    this.value = Boolean(this.answerValue === 'true' || this.answerValue === true);
    this.comment = this.answerComment;
  }

  onInputChange(value) {
    this.toggleComments();
    this.value = value;
    this.whenChanged(value);

    if (this.questionId) {
      onQuestionAnswered(this.questionId, value, this.comment);
    }
    if (this.canonicalName && this.fieldName) {
      onStateFieldAnswered(this.canonicalName, this.fieldName, value);
    }
  }

  onCommentChange(c = '') {
    this.comment = c;
    onQuestionAnswered(this.questionId, this.value, this.comment);
  }

  renderComment = () => {
    const commentClassList = {
      'mt-4': true,
      hidden: !this.showComment,
    };

    return (
      this.hasComment && (
        <div class={commentClassList}>
          <input-multiline
            label="Comments"
            shouldDisplayCharCount={true}
            maxLength={300}
            whenChanged={(c) => {
              this.onCommentChange(c);
            }}
            value={this.comment}
            data-testId={this.dataTestId ? `${this.dataTestId}InputMultiline` : null}
          />
        </div>
      )
    );
  };

  render() {
    const hostClass = {
      'question question--toggle': true,
      'has--comment': this.hasComment,
    };

    if (this.inputStyle === 'checkbox') {
      return (
        <div class={hostClass}>
          <input-checkbox
            titleText={this.heading}
            captionText={this.subHeading}
            errorMessage={this.errorMessage}
            hasError={this.isDirty && this.hasError}
            isChecked={this.value}
            whenChanged={(e) => this.onInputChange(e)}
            data-testId={this.dataTestId ? `${this.dataTestId}InputCheckBox` : null}
          />
          {this.renderComment()}
        </div>
      );
    }

    return (
      <div class={hostClass}>
        <input-checkbox-toggle
          titleText={this.heading}
          captionText={this.subHeading}
          errorMessage={this.errorMessage}
          hasError={this.isDirty && this.hasError}
          isChecked={this.value}
          whenChanged={(e) => this.onInputChange(e)}
          data-testId={this.dataTestId ? `${this.dataTestId}InputCheckBoxToggle` : null}
        />
        {this.renderComment()}
      </div>
    );
  }
}
